import styled, { css } from "styled-components";

export const PromosBannerContentContainer = styled.div<{ promosPage: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 50px;

  @media only screen and (max-width: 600px) {
    background: var(--fd-colors-background-promotional);
  }

  /* stylelint-disable media-feature-range-notation */
  @media only screen and (min-width: 920px) {
    display: flex;
    flex-direction: row;
    box-sizing: content-box;
    min-width: 385px;
    max-width: 575px;
  }

  @media only screen and (max-width: 919px) {
    width: 100%;
    padding: 16px;
  }
`;

export const PromosBannerContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  h3 {
    font-weight: normal;
  }

  @media only screen and (max-width: 699px) {
    display: flex;
    gap: 8px;

    h3 {
      font-size: 15px;
    }

    a,
    button {
      min-width: 100px;
      height: 40px;
    }
  }

  @media only screen and (min-width: 700px) and (max-width: 919px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px;

    h3 {
      font-size: 15px;
    }

    a,
    button {
      width: 100%;
      height: 40px;
    }
  }
`;

export const PromoBannerButtonWrapper = styled.div<{ promosPage: boolean }>`
  ${(props) =>
    props.promosPage === false
      ? css`
          @media only screen and (max-width: 599px) {
            display: none;
          }
        `
      : css`
          @media only screen and (max-width: 600px) {
            padding-bottom: 0;
          }
        `};
`;
